import get from "lodash.get";

class AbstractApiUtils {
  getApiTimestamp = (apiPayload) => get(apiPayload, "timestamp");

  // Return list type if specific parameter in filters
  // ex: areas --> retrieveListByAreas
  // ex: radius --> retrieveListByRadius
  getListNameFromType = (type) => {
    const listName = "retrieveList";

    switch (type) {
      case "areas":
        return `${listName}ByAreas`;
      case "radius":
        return `${listName}ByRadius`;
      default:
        return listName;
    }
  };
}

export default AbstractApiUtils;
